import { ReactElement } from "react";
import { IAddition } from "../../../types";
import HtmlTooltip from "../../../components/charts/tooltip";
import { formatTimeWithSeconds, toTons } from "../../../system/utils";
import KeyValueItem from "../../../components/charts/keyValueItem";
import { useTheme } from "@mui/material";

interface IProps {
  chartID: string;
  title: string;
  additions: IAddition[];
  y: number;
  xAccessorScaled: (addition: IAddition) => number;
}

const AdditionsLayerGantt = ({ additions, chartID, title, xAccessorScaled, y }: IProps): ReactElement => {
  const theme = useTheme();

  return (
    <>
      {additions.map((addition: IAddition, additionIndex: number ) => {
        const sampleKey = `${chartID}-sample-${additionIndex}`;

        const additionTitle = addition.source.sourceType === 0 ? "Alloys" : "Bucket";

        return (
          <g key={sampleKey}>
            <HtmlTooltip title={
              <div>
                <div className="display-flex-column align-items-center" >
                  <strong>{additionTitle}</strong>
                  <strong>{title}</strong>
                  <strong style={{ fontSize: "0.9em" }}>{formatTimeWithSeconds(addition.beginDatetime)}</strong>
                </div>
                <KeyValueItem name={addition.source.name}  value={ toTons(addition.weight).toFixed(2)} unit={"US ton"} />
              </div>
            }>
              <g transform={`translate(${xAccessorScaled(addition)}, ${y})`}>
                { addition.source.sourceType === 0
                  ? <rect  fill={"blue"} stroke={theme.palette.text.primary} x={0} y={0} width={8} height={8}/>
                  :
                  <circle stroke={theme.palette.text.primary} fill={"purple"} cx={2} cy={3} r={5}/>
                }
              </g>
            </HtmlTooltip>
          </g>
        );
      })
      }
    </>
  );
};

export default AdditionsLayerGantt;
